<template>
<v-card class="box-shadow-custom mr-4">
    <v-card width="500" class="mx-auto" flat v-if="no_data">
        {{ message }}
    </v-card>
    <v-skeleton-loader v-else :loading="loading" type="table-tfoot, image">
        <v-card  class="pa-4 grey--text elevation-0">
            <v-card-text class="py-0 mt-2">
                <v-row>
                    <v-col cols="12" md="4">
                        <v-card class="text-center" outlined>
                            <v-card-text style="padding: 8.5px;">
                                <span class="font-weight-bold">Credit Remaining :</span>
                                {{ userAccount.credit.left }}
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-card class="text-center" outlined>
                            <v-card-text style="padding: 8.5px;">
                                <span class="font-weight-bold">Credit Used :</span>
                                {{ userAccount.credit.used }}
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-dialog ref="dialog1" v-model="modal" :return-value.sync="date" persistent width="290px">
                            <template v-slot:activator="{ on }">
                                <span v-on="on">
                                    <v-combobox v-model="computedDateFormattedMomentjs" multiple label="Select Date" append-icon="mdi-calendar" outlined dense></v-combobox>
                                </span>
                            </template>
                            <v-date-picker v-model="date" color="primary" range>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                                <v-btn text color="primary" :disabled="date.length != 2" @click="onDate(date)">OK</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-col>
                </v-row>
                <Linesadmfls v-if="stats != ''" :stats="stats" />
            </v-card-text>
        </v-card>
    </v-skeleton-loader>
</v-card>
</template>

<script>
import {
    mapGetters,
    mapActions,
    mapMutations
} from 'vuex'
import moment from 'moment'
import _ from 'lodash'
export default {
    components: {
        Linesadmfls: () => import('../components/Chart/line.vue')
    },
    data() {
        return {
            date: [moment(new Date()).subtract(30, 'days').format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD")],
            modal: false,
            loading: false,
            onPlans: false,
            dialog: false,
            subscription: {},
            plans: {},
            loadingBilling: true,
            no_data: false,
            message: '',
            start: '',
            stats:'',
            defaultData: [
                { "label": "2019-07-29", "value": 0 },
                { "label": "2021-07-28", "value": 0 },
                { "label": "2021-07-25", "value": 0 }
            ]
        }
    },
    computed: {
        ...mapGetters(["userAccount"]),
        dateRangeText() {
            return this.date.join(' ~ ')
        },
        computedDateFormattedMomentjs() {
            return this.date.map(res => {
                return this.date ? moment(res).format('YYYY/MM/DD') : ''
            })
        }
    },
    methods: {
        ...mapActions(['GetResponse']),
        ...mapMutations(['UserAccount']),
        UpBill() {
            this.dialog = true
        },
        async getSubcription() {
            let strtDt = new Date(this.date[0]);
            let endDt = new Date(this.date[1]);
            let date = {};
            if (strtDt < endDt) {
                date.start = this.date[0];
                date.end = this.date[1];
            } else {
                date.end = this.date[0];
                date.start = this.date[1];
            }
            this.loading = true
            try {
                let url = `/internal/v2/usage-stats?start=${date.start}&end=${date.end}&sendEvent=1`
                const data = (await this.GetResponse(url)).data
                if (data.success) {
                    localStorage.setItem("account", JSON.stringify(data.data.account))
                    localStorage.setItem("user", JSON.stringify(data.data.user))
                    localStorage.setItem("credit", JSON.stringify(data.data.credit))
                    this.UserAccount()
                    let stat = []
                    Object.keys(data.data.stats).forEach(function(key) {
                        stat.push({label : key, value : parseInt(data.data.stats[key])})
                    });
                    this.stats = [{
                        data : _.sortBy(stat, 'label')
                    }]
                    this.loading = false
                    this.modal = false
                } else {
                    this.loadingBilling = false
                    this.no_data = true
                    this.message = data.message
                    this.loading = false
                    this.modal = false
                }
            } catch (err) {
                console.log(err)
                this.loading = false
                this.modal = false
            }
        },
        getMoment(date) {
            return moment(date).format('MMMM DD YYYY h:mm a');
        },
        async onDate(date) {
            this.$refs.dialog1.save(date)
            await this.getSubcription();
        },
    },
    async mounted() {
        await this.getSubcription()
    }
}
</script>
